import React from "react";
import { LogoProps } from "./index";

const LogoMark: React.FC<LogoProps> = ({ height = 30, className }) => {
  return (
    <svg
      width="auto"
      height={height}
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_3_87)">
        <path
          d="M1.25227 9C2.5339 8.53556 4.00242 8.55211 5.25088 9.04029L6.0004 9.33337C7.10545 9.76548 7.89282 10.5082 8.43735 11.3693C8.64264 10.9982 8.8801 10.6433 9.14821 10.3089C10.2034 8.99264 11.6715 8.07056 13.3154 7.69164C14.9593 7.31272 16.6829 7.49908 18.2078 8.22061C18.5908 8.40185 18.9557 8.61419 19.2992 8.85454C20.9963 10.0417 23.2234 10.9222 25.0789 10.0021C26.9343 9.08203 27.7226 6.78865 26.372 5.21852C25.0114 3.63667 23.3265 2.34539 21.4156 1.44122C18.3658 -0.00184214 14.9185 -0.37456 11.6308 0.383285C8.34302 1.14113 5.40677 2.98527 3.29641 5.61778C2.46324 6.6571 1.77801 7.79533 1.25227 9Z"
          fill="var(--cdl-accent-fg-base)"
        />
        <path
          d="M27.1842 23.602C28.3922 21.9197 27.4063 19.7042 25.4775 18.95L24.728 18.6569C23.2131 18.0645 21.5351 18.8765 20.4081 20.0494C19.7256 20.7596 18.91 21.3285 18.0078 21.7234C17.1056 22.1184 16.1343 22.3318 15.1496 22.3515C14.1649 22.3711 13.186 22.1966 12.2687 21.838C11.3514 21.4793 10.5138 20.9434 9.80356 20.261C9.09336 19.5786 8.52453 18.763 8.12954 17.8608C7.73455 16.9585 7.52114 15.9873 7.50149 15.0026C7.46904 13.3763 6.78695 11.6415 5.27204 11.0491L4.52253 10.756C2.59368 10.0018 0.366436 10.9609 0.112857 13.0164C0.025655 13.7233 -0.0112869 14.437 0.00298573 15.1522C0.0422852 17.1217 0.469109 19.0641 1.25909 20.8686C1.37114 21.1245 1.49019 21.377 1.61604 21.6257L0.101905 27.4776C-0.283752 28.9682 1.08874 30.3172 2.5724 29.906L8.35786 28.3022C8.74275 28.4923 9.13626 28.6661 9.53737 28.8229C11.3719 29.5403 13.3298 29.8893 15.2993 29.85C17.2687 29.8107 19.2111 29.3839 21.0156 28.5939C22.8201 27.8039 24.4513 26.6663 25.8161 25.2459C26.3118 24.73 26.7688 24.1805 27.1842 23.602Z"
          fill="var(--color-chart-green-base)"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_87">
          <rect width="28" height="30" fill="var(--color-bg-base)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LogoMark;
